import { render, staticRenderFns } from "./RegistrationNavbar.vue?vue&type=template&id=0547f737&scoped=true"
import script from "./RegistrationNavbar.vue?vue&type=script&lang=js"
export * from "./RegistrationNavbar.vue?vue&type=script&lang=js"
import style0 from "./RegistrationNavbar.vue?vue&type=style&index=0&id=0547f737&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547f737",
  null
  
)

export default component.exports